/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthResDto } from '../../models/auth-res-dto';

export interface AuthControllerSetSessionOrganizzazione$Params {
  idOrganizzazione: number;
}

export function authControllerSetSessionOrganizzazione(
  http: HttpClient,
  rootUrl: string,
  params: AuthControllerSetSessionOrganizzazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<AuthResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    authControllerSetSessionOrganizzazione.PATH,
    'put',
  );
  if (params) {
    rb.path('idOrganizzazione', params.idOrganizzazione, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuthResDto>;
      }),
    );
}

authControllerSetSessionOrganizzazione.PATH =
  '/auth/session/organizzazione/id/{idOrganizzazione}';
